import { create } from "zustand";

interface OpenedWindowsState {
    openedWindows: { [key: string]: Window | null };
    openWindow: (id: string, path: string) => void;
    closeWindow: (id: string) => void;
}

export const useOpenedWindowsStore = create<OpenedWindowsState>((set, get) => ({
    openedWindows: {},

    openWindow: (id, path) => {
        const { openedWindows } = get();

        if (openedWindows[id] && !openedWindows[id]?.closed) {
            openedWindows[id]!.location.href = path;
            openedWindows[id]?.focus();
        } else {
            const newWindow = window.open(path, id);
            if (newWindow) {
                set(state => ({
                    openedWindows: { ...state.openedWindows, [id]: newWindow },
                }));

                newWindow.addEventListener("beforeunload", () => {
                    get().closeWindow(id);
                });
            }
        }
    },

    closeWindow: id => {
        set(state => {
            const updatedWindows = { ...state.openedWindows };
            delete updatedWindows[id];
            return { openedWindows: updatedWindows };
        });
    },
}));
